








































































import { Component, Prop } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';
import dayjs from 'dayjs';
import { mixins } from 'vue-class-component';
import { PaginationMixin } from '@/components/base/pagination.mixin';
import { Journal } from '@/store/modules/journal';
import BaseTable from '@/components/BaseTable.vue';
import BaseLoading from '@/components/base/BaseLoading.vue';
import BasePagination from '@/components/base/BasePagination.vue';
import { cloneDeep as _cloneDeep } from 'lodash';

@Component({
  components: {
    BaseTable,
    BasePagination,
    BaseLoading
  }
})
export default class JournalList extends mixins(PaginationMixin) {
  @Prop() public items!: Journal[];
  @Prop(Number) public currentPage!: number;
  @Prop(Number) public totalNumberOfPage!: number;
  @Prop(Number) public totalCount!: number;
  @Prop(Boolean) public isFirstPage!: boolean;
  @Prop(Boolean) public isLastPage!: boolean;
  @Prop(Number) public startItemIndex!: number;
  @Prop(Number) public endItemIndex!: number;

  get journalItems() {
    return this.items || [];
  }

  get dayjs() {
    return dayjs;
  }

  public handleStatus(status: string) {
    const transformText = status.replace('_', ' ').toLowerCase();
    return transformText.charAt(0).toUpperCase() + transformText.slice(1);
  }
  public getUserName(item: Journal) {
    return item.payment.user.userProfile
      ? item.payment.user.userProfile.firstName +
          ' ' +
          item.payment.user.userProfile.lastName
      : item.payment.user.email;
  }

  public redirectToUserSubscriptionPage(item: Journal) {
    // Define query parameters with the correct types expected by the backend API
    // The backend requires all parameters to be properly formatted strings
    // The applicationId should be a valid app ID and productId should start with a value
    // Also including groupProductId parameter which is required by the API to avoid NaN errors
    const query = {
      tab: 'Subscriptions',
      email: item.payment.user.email,
      applicationId: 'paces', // Default to 'paces' application
      productId: '0', // Default to '0' for "all products"
      groupProductId: '0', // Adding this prevents NaN errors in the API
      limit: '50', // Set a reasonable page size
      page: '1', // Start at first page
      sortColumn: 'email', // Default sort column
      sortOrder: 'ASC' // Default sort order
    };

    if (
      item.payment.order.orderItems &&
      item.payment.order.orderItems.length > 0
    ) {
      const orderItem = item.payment.order.orderItems[0];
      // Fix: Previously tried to access 'applicationProductId' which doesn't exist on OrderItem
      // TypeScript was complaining because this property isn't in the interface
      // Instead, use the 'id' property which is guaranteed to exist and convert to string
      query.productId = orderItem.id.toString();

      // Only set applicationId if it exists in the order item
      if (orderItem.applicationId) {
        query.applicationId = orderItem.applicationId;
      }
    }

    // Use router.replace instead of router.push to replace current history entry
    this.$router.replace({ path: '/admin/user-management', query });
  }

  /**
   * Format money values with currency
   * This method is required but wasn't defined in the component, causing TypeScript errors
   */
  public moneyParser(options: { currency: string; value: number }): string {
    const { currency, value } = options;
    return `${currency} ${(value / 100).toFixed(2)}`;
  }

  /**
   * Format the upload date with proper formatting
   *
   * The uploadedToUofaSftpAt property exists in the API response data
   * but is not defined in the TypeScript Journal interface.
   * Using type assertion to tell TypeScript that this field
   * is available on the runtime object.
   */
  public formatUploadDate(item: Journal): string {
    // Use type assertion to access the property that exists at runtime
    // but is not defined in the TypeScript interface
    const journalWithUploadDate = item as Journal & {
      uploadedToUofaSftpAt?: string;
    };

    return journalWithUploadDate.uploadedToUofaSftpAt
      ? dayjs(journalWithUploadDate.uploadedToUofaSftpAt).format(
          'DD MMM YYYY, h:mm A'
        )
      : '';
  }
}
